import { Vectors as o } from "./index36.js";
const t = [
  {
    normal: o.Forward,
    pivots: [[0, 0, 1], [0, 1, 1], [1, 0, 1], [1, 1, 1]]
  },
  {
    normal: o.Back,
    pivots: [[0, 0, 0], [0, 1, 0], [1, 0, 0], [1, 1, 0]]
  },
  {
    normal: o.Right,
    pivots: [[1, 0, 0], [1, 0, 1], [1, 1, 0], [1, 1, 1]]
  },
  {
    normal: o.Left,
    pivots: [[0, 0, 0], [0, 0, 1], [0, 1, 1], [0, 1, 0]]
  },
  {
    normal: o.Up,
    pivots: [[0, 1, 0], [0, 1, 1], [1, 1, 1], [1, 1, 0]]
  },
  {
    normal: o.Down,
    pivots: [[0, 0, 0], [0, 0, 1], [1, 0, 1], [1, 0, 0]]
  }
];
export {
  t as PivotsByNormal
};
//# sourceMappingURL=index23.js.map
